import React, { Fragment } from "react";
import { Input } from "sulu-admin-bundle/components";
import { FieldTypeProps } from "sulu-admin-bundle/types";

export default class YTLink extends React.Component<FieldTypeProps<?string>> {
  handleVideoUrl = (yt) => {
    let { url } = yt;
    if (!url.includes("https://")) {
      url = "https://youtu.be/" + url;
    }

    yt.urlData = new URLSearchParams(new URL(url).search);

    return yt;
  };

  handleVideoTime = (yt) => {
    let { start, urlData } = yt;

    start = urlData.get("t") ? urlData.get("t") : urlData.get("start");

    if (start) {
      yt.start = start.replace("s", "");
    }

    return yt;
  };

  handleVideoID = (yt) => {
    let { urlData, url } = yt;

    if (urlData.get("v")) {
      yt.id = urlData.get("v");
    } else if (url.includes("https://youtu.be/")) {
      yt.id = url.split("/").slice(-1)[0].split("?")[0];
    } else if (url.includes("https://www.youtube.com/embed/")) {
      yt.id = url.split("/").slice(-1)[0].split("?")[0];
    }

    return yt;
  };

  handleInputChange = (value) => {
    let yt = { start: 0, id: null, url: value };

    let { handleVideoUrl, handleVideoTime, handleVideoID, props } = this;

    yt = handleVideoUrl(yt);
    yt = handleVideoTime(yt);
    yt = handleVideoID(yt);

    if (!yt.id) {
      props.onChange("");
    } else {
      if (yt.start) {
        yt.id += "?start=" + yt.start;
      }

      props.onChange(yt.id);
    }

    props.onFinish();
  };

  render() {
    const { dataPath, error, disabled, onChange, value } = this.props;

    return (
      <Fragment>
        <div className={"ctf-yt_link-parent"}>
          <div className={"ctf-yt_link-left"}>https://youtu.be/</div>
          <div className={"ctf-yt_link-right"}>
            <Input
              placeholder="MwpMEbgC7DA"
              disabled={!!disabled}
              id={dataPath}
              onChange={this.handleInputChange}
              valid={!error}
              value={value}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}
